export default function getAuthHeaders() {
    const admin = localStorage.getItem('admin');
    return {
        headers: {
            "Authorization": `Bearer ${admin ? JSON.parse(admin).token : ""}`
        }
    }
}